
import { Book, ProductAddedSource } from 'types';
import Button from '../button';
import Links from '~/lib/helpers/link-helper';
import useAnalytics from '../../lib/hooks/use-analytics';
import { useRouter } from 'next/navigation';
import { useGlobalState } from '../../state';

interface BuyitNowButtonProps {
  book: Book;
  disabled?: boolean;
  source: ProductAddedSource;

}

export default function BuyitNowButton({
  book,
  disabled,
  source,
}: BuyitNowButtonProps) {
  const { analyticEvents } = useAnalytics();
  const router = useRouter();
  const { state } = useGlobalState();
  const uid = state?.user?.data?.uid;

  function handleBuyitNow() {
    analyticEvents.checkoutProcess('Buy It Now', { source, book_id: book?.id, title_id: book?.title_id });
    router.push(Links.checkout({ ids: [book?.id], cid: uid }).url);
  }


  return (
    <Button
      text={'Buy it now'}
      disabled={disabled}
      style='secondary'
      onPress={handleBuyitNow}
    />
  );
}